import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box, Typography, Grid, Divider } from '@material-ui/core'
import { Cards } from '../../elements'
import { useStyles } from './style'
import Breadcrumb from '../../Components/Breadcrumbs'
import NotSelected from './ReportForms/NotSelected'
import ProgramSummary from './ReportForms/ProgramSummary'
import EventsSummary from './ReportForms/EventsSummary'
import EventTelemetryReport from './ReportForms/EventTelemetryReport'
import ProductionForecast from './ReportForms/ProductionForecasting'
import SystemDetailsReport from './ReportForms/SystemDetailsReport'
import EventParticipationReport from './ReportForms/EventParticipationReport'
import * as ReportName from './constant'
import { programService } from '../../Services'
import { DisplayMessage, Loader } from '../../Components'
import { accountService } from '../../Services/AccountService/AccountService'
import * as messageTypes from '../../utils/messageTypes'
import _ from 'lodash'
import { COMMON } from '../../utils/constants'
import { AppButton } from '../../Components'

function Reports(props) {
  const classes = useStyles()

  const [selectedReport, setSelectedReport] = useState(ReportName.NOT_SELECTED)
  const [loading, setLoading] = useState(true)
  const [programs, setPrograms] = useState([])
  const [allAccounts, setAllAccounts] = useState([])
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()

  const reportMap = {
    [ReportName.NOT_SELECTED]: <NotSelected />,
    [ReportName.PROGRAM_SUMMARY]: <ProgramSummary name={ReportName.PROGRAM_SUMMARY} accounts={allAccounts} />,
    [ReportName.EVENTS_SUMMARY]: <EventsSummary programs={programs} accounts={allAccounts} />,
    [ReportName.EVENT_TELEMETRY_REPORT]: <EventTelemetryReport programs={programs} accounts={allAccounts} />,
    [ReportName.PRODUCTION_FORECASTING]: <ProductionForecast name={ReportName.PRODUCTION_FORECASTING} programs={programs} accounts={allAccounts} />,
    [ReportName.LOAD_BUILD_FORECASTING]: <ProductionForecast name={ReportName.LOAD_BUILD_FORECASTING} programs={programs} accounts={allAccounts} forecast_report_type="LOAD_BUILD" />,
    [ReportName.LOAD_REDUCTION_FORECASTING]: <ProductionForecast name={ReportName.LOAD_REDUCTION_FORECASTING} programs={programs} accounts={allAccounts} forecast_report_type="LOAD_REDUCTION" />,
    [ReportName.ENERGY_AVAILABLE_FORECASTING]: <ProductionForecast name={ReportName.ENERGY_AVAILABLE_FORECASTING} programs={programs} accounts={allAccounts} forecast_report_type="ENERGY_AVAILABLE" />,
    [ReportName.SYSTEM_DETAILS_REPORT]: <SystemDetailsReport name={ReportName.SYSTEM_DETAILS_REPORT} accounts={allAccounts} />,
    [ReportName.EVENT_PARTICIPATION_HISTORY]: <EventParticipationReport name={ReportName.EVENT_PARTICIPATION_HISTORY} programs={programs} accounts={allAccounts} />,
    [ReportName.USER_SUMMARY]: <ProgramSummary name={ReportName.USER_SUMMARY} accounts={allAccounts} />,
  }

  const handleClick = (e) => {
    setSelectedReport(e.target.textContent)
  }

  const getAllPrograms = () => {
    const { currentUser } = props
    setLoading(true)
    programService.getAllAvailablePrograms(currentUser.account_id)
      .then(programsData => {
        setPrograms(programsData)
        setLoading(false)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setLoading(false)
      })
  }

  const getAllAccounts = () => {
    const { currentUser } = props
    setLoading(true)
    accountService.getAllAccounts(currentUser.account_id)
      .then(accountsData => {
        setAllAccounts(accountsData)
        setLoading(false)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setLoading(false)
      })
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  useEffect(() => {
    getAllPrograms()
    if (props.isSuperAdmin || props.isViewOnly) {
      getAllAccounts()
    } else {

    }
  }, [])

  const getReportsCard = () => {
    return (
      <Grid container justify="center" alignContent="center">
        <Grid container item md={3}>
          <Grid item xs={12}>
            <Box className={classes.container} mb={3}>
              <div className={classes.heading}>Programs & Events</div>
              <div className={`${classes.content} ${selectedReport === ReportName.PROGRAM_SUMMARY ? classes.bold : ''}`} onClick={handleClick}>{ReportName.PROGRAM_SUMMARY}</div>
              <div className={`${classes.content} ${selectedReport === ReportName.EVENTS_SUMMARY ? classes.bold : ''}`} onClick={handleClick}>{ReportName.EVENTS_SUMMARY}</div>
              <div className={`${classes.content} ${selectedReport === ReportName.EVENT_TELEMETRY_REPORT ? classes.bold : ''}`} onClick={handleClick}>{ReportName.EVENT_TELEMETRY_REPORT}</div>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.container} mb={3}>
              <div className={classes.heading}>System Level Reports</div>
              <div className={`${classes.content} ${selectedReport === ReportName.SYSTEM_DETAILS_REPORT ? classes.bold : ''}`} onClick={handleClick}>{ReportName.SYSTEM_DETAILS_REPORT}</div>
              <div className={`${classes.content} ${selectedReport === ReportName.EVENT_PARTICIPATION_HISTORY ? classes.bold : ''}`} onClick={handleClick}>{ReportName.EVENT_PARTICIPATION_HISTORY}</div>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.container}>
              <div className={classes.heading}>Users Reports</div>
              <div className={`${classes.content} ${selectedReport === ReportName.USER_SUMMARY ? classes.bold : ''}`} onClick={handleClick}>{ReportName.USER_SUMMARY}</div>
            </Box>
          </Grid>
        </Grid>
        <Grid item md={1}>
          <Divider orientation="vertical" flexItem style={{ height: '100%', marginLeft: '30%' }} />
        </Grid>
        <Grid container item md={8}>
          <Grid className={classes.reportForm} item xs={12}>
            {reportMap[selectedReport]}
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <Box>
      <Breadcrumb value={[{ 'Home': '/' }, { 'Reports': '/reports' }]} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={handleMessageClose} />
      <Loader loading={loading} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Reports</Typography>
        {(props.isSuperAdmin || props.isViewOnly) && <Box className={classes.summaryGrid}>
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Site Event Viewer" onClick={() => props.history.push('/reports/event-viewer')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Active Sites" onClick={() => props.history.push('/reports/active-sites')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Daily Discharge Viewer" onClick={() => props.history.push('/reports/daily-discharge-viewer')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="API Hits Viewer" onClick={() => props.history.push('/reports/api-hits-viewer')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Site Ids Viewer" onClick={() => props.history.push('/reports/site-ids-viewer')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Site Daily Performance" onClick={() => props.history.push('/reports/site-daily-performance')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Invoice Viewer" onClick={() => props.history.push('/reports/invoice-viewer')} fill={false} />
          <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Program Wise Invoice" onClick={() => props.history.push('/reports/program-wise-invoice-viewer')} fill={false} />
        </Box>}
      </Box>
      <Cards className={classes.cardWrapper} children={getReportsCard()} />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isViewOnly } = auth
  return { currentUser, isSuperAdmin, isViewOnly }
}

export default connect(mapStateToProps, {})(Reports)
